module.exports = __webpack_public_path__ + "static/media/stand_5.1aba3379.png";